const list = ['K749','KB29','KB30','KB31','KB32','LE95','LF52','LF85','LH77','LH78','LH79','LP92','LY31','LY49','ME50','MJ40','MJ41','MY37','NH63','NH64','NH65','NH66','NH68','NH69','X622','X918','Y634','NL64','NL65','NL66','NL67','NL69','NL70','NZ28','NZ29','NZ30','NZ53','OE69','OE70','OE71','OE72','OE74','OE75','OE77','OE78','NZ28','NZ29','NZ30','NZ53','OG61','OG61','OG62','OG63','OG64','OG65','OG66','OE74','OE75','ON04','ON05','ON06','ON07','ON08','ON09','ON10','ON11','LH81','LV00','OV64','OV65','OV66','OV67','OV68','OV69','OV71','OV72','X630','OX77','PI15','PI16','PI17','PI18','PI19','PI20','PI21','PI22','ON02','LV04','OC91','OC92','OR78','PJ52','PJ53','PJ54','PJ55','PJ56',];
const gifList = []; 
const ajax_url = 'https://tool.m3guo.com/api/web/m3goods/eq-item/';
const img_src = 'https://web-resource.17m3.com/cdn/m3-eq-tip/';
const img_file = '.jpg';

export default{
    list,
    gifList,
    ajax_url,
    img_src,
    img_file,
}